import React, { createContext, useEffect, useState } from "react";
import {
  userDetailsApi,
  editUserInfo,
  deleteProfilePicApi,
  generateMfaCode,
  verifyAppMfaCode,
} from "../../../api/Api";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import routeConstants from "../../../constants/routeConstants.json";
import { validateMobileNumber } from "../../../utils/service";
import axios from "axios";
import { useGlobalContext } from "../../../GlobalState/GlobalContext";

export const EditProfileContext = createContext({});
export const EditProfileContextProvider = ({ children }) => {
  const [spinnerStatus, setSpinnerStatus] = useState(false);

  // const [currentUserDetails, setCurrentUserDetails] = useState({});
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState();
  const [role, setRole] = useState("");
  const [userId, setUserId] = useState();

  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [notificationPreferences, setNotificationPreferences] = useState([]);
  const [invalidNumberMsg, setInvalidNumberMsg] = useState("");
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState("");
  const [statusCode, setStatusCode] = useState();
  const [invalidImageMsg, setInvalidImageMsg] = useState("");
  const [editNotificationPreference, setEditNotificationPreference] = useState(
    []
  );
    const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    setError("");
  };
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [showDeleteErrorPopup, setShowDeleteErrorPopup] = useState(false);
  const [verifyQrPopup, setVerifyQrPopup] = useState("");
  const [errorQrPopup, setErrorQrPopup] = useState("");
  
  const [qrCode, setQrCode] = useState("");
  const [authCode, setAuthCode] = useState();
  const [verifyMfaCode, setVerifyMfaCode] = useState(0);

  const [mfaDetails, setMfaDetails] = useState("Disabled");

  const [mfaCheckBox, setMfaCheckBox] = useState();
  const [multiFactorAuthApp, setMultiFactorAuthApp] = useState();
  const [multiFactorEmail, setMultiFactorEmail] = useState();

  const [showQrAlert, setShowQrAlert] = useState();
  const [authType, setAuthType] = useState("Disabled");
  const [authToken, setAuthToken] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [buttonText, setButtonText] = useState("");
  const { globalProfile, setGlobalProfile } = useGlobalContext();

  const [errorPopup, setErrorPopup] = useState(false);
  const [errorPopupMessage, setErrorPopupMessage] = useState(false);
  const [statusValue, setStatusValue] = useState(false);
  const navigate = useNavigate();

  const baseUrl = "https://salesservices.codelynks.in/";
  const fullImageUrl = profileImageUrl ? `${baseUrl}${profileImageUrl}` : false;

  useEffect(() => {
    getUserDetails();
  }, []);

  const getUserDetails = async () => {
    try {
      setSpinnerStatus(true);
      const userDetails = await userDetailsApi();
      setName(userDetails?.data?.data?.profile?.name);
      setEmail(userDetails?.data?.data?.profile?.email);
      setPhoneNumber(userDetails?.data?.data?.profile?.mobile);
      setRole(userDetails?.data?.data?.profile?.role?.name);
      setProfileImageUrl(userDetails?.data?.data?.profile?.profileImage);
      setNotificationPreferences(
        userDetails?.data?.data?.profile?.notificationPreferences
      );
      // setGlobalProfile(userDetails?.data?.data?.profile?.profileImage);

      setMfaDetails(
        userDetails?.data?.data?.profile?.multiFactorAuthentication
      );
      setUserId(userDetails?.data?.data?.profile?._id);
      // console.log("userDetails", userDetails?.data?.data?.profile?._id);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      setStatusValue(error?.response?.data?.statusCode);

      if (error?.response?.data?.statusCode === 400) {
        setErrorPopupMessage(errorMessage);
        setErrorPopup(true);
        setButtonText("Try Again");
      } else if (
        error?.response?.data?.statusCode === 401 ||
        error?.response?.data?.statusCode === 403
      ) {
        setErrorPopupMessage(errorMessage);
        setButtonText("Login");
        setErrorPopup(true);
      } else {
        setErrorPopup(true);
        setErrorPopupMessage("Something went wrong...");
        setButtonText("Try Again");
      }
    }
    setSpinnerStatus(false);
  };

  const generateMfa = async () => {
    try {
      const mfaCode = await generateMfaCode();
      console.log("mfaCode", mfaCode);
      // console.log("mfaCode", mfaCode.status);
      setAuthToken(mfaCode?.data?.data?.authToken);
      setQrCode(mfaCode?.data?.data?.qrCode);
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      setStatusValue(error?.response?.data?.statusCode);

      if (error?.response?.data?.statusCode === 400) {
        setErrorPopupMessage(errorMessage);
        setErrorPopup(true);
        setButtonText("Try Again");
      } else if (
        error?.response?.data?.statusCode === 401 ||
        error?.response?.data?.statusCode === 403
      ) {
        setErrorPopupMessage(errorMessage);
        setButtonText("Login");
        setErrorPopup(true);
      } else {
        setErrorPopup(true);
        setErrorPopupMessage("Something went wrong...");
        setButtonText("Try Again");
      }
    }
  };

  const verifyAppMfa = async (userId, code, authToken) => {
    try {
      const verifyCode = await verifyAppMfaCode(userId, code, authToken);
      setVerifyMfaCode(verifyCode?.status);

      if (verifyCode?.status === 200) {
        onSubmitEditedInfo();
        setShowSuccessPopup(true);
      } else {
        console.log("Verification failed for App authentication.");
        setAuthCode();
      }

      console.log("VerifyCode", verifyCode?.status);
    } catch (error) {
      setErrorQrPopup(true);
      setAuthCode();
      setStatusValue(error?.response?.data?.statusCode);

      const errorMessage = error?.response?.data?.message;

      if (error?.response?.data?.statusCode === 400) {
        setErrorPopupMessage(errorMessage);
        setErrorQrPopup(true);
        setButtonText("Try Again");
      } else if (
        error?.response?.data?.statusCode === 401 ||
        error?.response?.data?.statusCode === 403
      ) {
        setErrorPopupMessage(errorMessage);
        setButtonText("Login");
        setErrorQrPopup(true);
      } else {
        setErrorQrPopup(true);
        setErrorPopupMessage("Something went wrong...");
        setButtonText("Try Again");
      }
    }
  };
  // verifyMfa(userId,authCode,authToken);

  const handleCheckboxToggle = (type, field) => {
    setEditNotificationPreference((prevPreferences) =>
      prevPreferences.map((item) =>
        item.type === type ? { ...item, [field]: !item[field] } : item
      )
    );
  };

  const handleMultiFactorCheckboxClick = () => {
    //  This is for unchecking both other checkboxes when
    //  Multifactor checkbox is clicked
    setMfaCheckBox((prev) => {
      const newAuthState = !prev;
      if (!newAuthState) {
        setMultiFactorEmail(false);
        setMultiFactorAuthApp(false);
        setAuthType("Disabled");
      }
      return newAuthState;
    });
  };

  const phoneNumberOnChange = (e) => {
    const value = e.target.value;
    setPhoneNumber(value);

    // Clear error message while typing
    if (invalidNumberMsg && validateMobileNumber(value)) {
      setInvalidNumberMsg("");
    }
  };

  const phoneNumberOnBlur = () => {
    if (!validateMobileNumber(phoneNumber)) {
      setInvalidNumberMsg("Enter 10-digit number");
    } else {
      setInvalidNumberMsg("");
    }
  };

  const handleThemeBtnClick = () => {
    if (mfaDetails === "App") {
      onSubmitEditedInfo();
      return;
    }

    if (!mfaCheckBox) {
      // Allow submission if MFA checkbox is not checked
      onSubmitEditedInfo();
      return;
    }

    // Handle MFA cases
    if (authType === "App") {
      generateMfa();
      setShowQrAlert(true);
    } else if (authType === "Email") {
      onSubmitEditedInfo();
    } else {
      console.error("Invalid authType for multi-factor authentication.");
    }
  };

  const goToLogin = () => {
    removeCookie("x-access-token");
    navigate(routeConstants.LOGIN);
  };

  const onSubmitEditedInfo = async () => {
    let formDataInfo = new FormData();
    formDataInfo.append("mobile", phoneNumber);
    formDataInfo.append("multiFactorAuthentication", authType);
    formDataInfo.append(
      "notificationPreferences",
      JSON.stringify(editNotificationPreference)
    );

    if (file) {
      formDataInfo.append("profileImage", file);
    } else {
      formDataInfo.append("profileImage", "");
    }

    if (!invalidNumberMsg && !invalidImageMsg) {
      try {
        setSpinnerStatus(true);
        const response = await editUserInfo(formDataInfo);
        setStatusCode(response?.data?.statusCode);

        if (response?.data?.statusCode === 200) {
          console.log("response prof", response);
          setShowSuccessPopup(true); // Show success popup
          setSuccessMessage(response?.data?.message);
          setShowErrorPopup(false);
          setSpinnerStatus(false);
        }
      } catch (error) {
        setSpinnerStatus(false);
        setStatusValue(error?.response?.data?.statusCode);

        if (error?.response?.data?.statusCode === 400) {
          const errorMessage = error?.response?.data?.message;
          setPopupMessage(errorMessage);
          setShowErrorPopup(true);
          setShowSuccessPopup(false);
          setButtonText("Try Again");
        } else if (
          error?.response?.data?.statusCode === 401 ||
          error?.response?.data?.statusCode === 403
        ) {
          const errorMessage = error?.response?.data?.message;
          setPopupMessage(errorMessage);
          setShowErrorPopup(true);
          setShowSuccessPopup(false);
          setButtonText("Login");
        } else {
          setPopupMessage("Something went wrong...");
          setShowErrorPopup(true);
          setShowSuccessPopup(false);
          setButtonText("Try Again");
        }
      }
    }
  };

  // console.log("file", file);

  const handleDelete = async () => {
    setShowDeletePopup(false);
    setShowErrorPopup(false);
    try {
      const response = await deleteProfilePicApi();
      console.log(response);
      if (response.status === 200) {
        setShowDeletePopup(true);
        // setShowErrorPopup(true);
        setPopupMessage(response?.data?.message);
        handleClose();
      } else {
        setShowDeleteErrorPopup(true);
      }
    } catch (error) {
      setShowDeleteErrorPopup(true);
      handleClose();
      setStatusValue(error?.response?.data?.statusCode);

      const errorMessage = error?.response?.data?.message;

      if (error?.response?.data?.statusCode === 400) {
        setErrorPopupMessage(errorMessage);
        setShowDeleteErrorPopup(true);
        setButtonText("Try Again");
      } else if (
        error?.response?.data?.statusCode === 401 ||
        error?.response?.data?.statusCode === 403
      ) {
        setErrorPopupMessage(errorMessage);
        setButtonText("Login");
        setShowDeleteErrorPopup(true);
      } else {
        setShowDeleteErrorPopup(true);
        setErrorPopupMessage("Something went wrong...");
        setButtonText("Try Again");
      }
    }
  };

  const validateImage = (image) => {
    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const maxFileSize = 2 * 1024 * 1024; // 2MB

    // Clear previous error messages
    setInvalidImageMsg("");

    // Validate file type
    if (!allowedTypes.includes(image.type)) {
      setInvalidImageMsg("Only JPEG, PNG, and JPG files are allowed");
      return false;
    }

    // Validate file size
    if (image.size > maxFileSize) {
      setInvalidImageMsg("File size should be less than 2MB");
      return false;
    }

    // No validation errors
    return true;
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    // const validationError = validateImage(selectedFile);

    if (!validateImage(selectedFile)) {
      setError("Only JPEG, PNG, and JPG files under 2MB are allowed");
      setFile(null);
      setPreview(null);
    } else {
      setError("");
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
      handleClose();
    }
  };
  // console.log("file", file);

  const providerValue = {
    name,
    role,
    email,
    phoneNumber,
    setName,
    phoneNumberOnChange,
    notificationPreferences,
    fullImageUrl,
    onSubmitEditedInfo,
    invalidNumberMsg,
    handleFileChange,
    preview,
    error,
    show,
    setShow,
    handleClose,
    handleShow,
    handleDelete,
    navigate,
    routeConstants,
    showSuccessPopup,
    showErrorPopup,
    showDeletePopup,
    showDeleteErrorPopup,
    setShowSuccessPopup,
    setShowErrorPopup,
    setShowDeletePopup,
    setShowDeleteErrorPopup,
    spinnerStatus,
    handleCheckboxToggle,
    setEditNotificationPreference,
    editNotificationPreference,
    generateMfa,
    qrCode,
    authCode,
    setAuthCode,
    mfaCheckBox,
    setMfaCheckBox,
    multiFactorAuthApp,
    setMultiFactorAuthApp,
    showQrAlert,
    setShowQrAlert,
    authType,
    setAuthType,
    userId,
    authToken,
    verifyAppMfa,
    multiFactorEmail,
    setMultiFactorEmail,
    handleMultiFactorCheckboxClick,
    verifyMfaCode,
    mfaDetails,
    verifyQrPopup,
    setVerifyQrPopup,
    errorQrPopup,
    setErrorQrPopup,
    handleThemeBtnClick,
    phoneNumberOnBlur,
    validateImage,
    setPreview,
    setError,
    popupMessage,
    successMessage,

    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    setErrorPopupMessage,
    buttonText,
    setButtonText,
    goToLogin,
    statusValue,
    setStatusValue,
    getUserDetails,
  };

  return (
    <EditProfileContext.Provider value={providerValue}>
      {children}
    </EditProfileContext.Provider>
  );
};
